import React from 'react';
import { Account_AccountData_account } from '../../types/graph/Account_AccountData';
import Grid from './Integrations/Grid';
import ComingSoon from '../../components/ComingSoon';
import { GetFeatureState } from '../../hooks/getFeatureState';

interface Props {
  account: Account_AccountData_account;
}

const Integrations: React.FC<Props> = ({ account }) => {
  const IntegrationsSectionEnabled = GetFeatureState('IntegrationsSection');

  return (
    <div className="h-full shadow rounded-lg bg-white">
      <div className="py-6 px-4 sm:p-6 lg:pb-8">
        <div>
          <h2 className="text-lg leading-6 font-medium text-gray-900">
            Integrations
          </h2>
          <p className="mt-1 text-sm text-gray-500">
            Manage 3rd party account integrations.
          </p>
        </div>

        <div className="mt-10">
          {IntegrationsSectionEnabled ? (
            <Grid account={account} />
          ) : (
            <div className="shadow rounded-lg">
              <ComingSoon
                label={`On it's way`}
                title="Social Network Integrations"
                description={`Integration of social networks to save you time marketing your brand. We're building integrations with all the popular social networks to make it that much easier to get seen.`}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Integrations;
